




















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import Bill from "../../models/bill/Bill";
import ReportList from "@/components/report/ReportList.vue";
import ReportListFilter from "@/models/report/ReportListFilter";
import ReportListEntry from "@/models/report/ReportListEntry";
import {BillState} from "@/helpers/constants";
import AsiBtn from "@/components/common/AsiBtn.vue";
import AsiToolbar from "@/components/common/AsiToolbar.vue";
import {Icon} from "@/helpers/icons";
import {SnackbarMessage} from "@/models/SnackbarMessage";

@Component({
	components: {AsiToolbar, AsiBtn, ReportList, AsiContentContainer}
})
export default class BillTabReports extends Vue {

	@Prop({type: Object, required: true})
	public bill!: Bill;

	@Prop({type: Boolean, default: false})
	public loading!: boolean;

	private icons = Icon;
	private selectedReports: ReportListEntry[] = [];
	private editMode: boolean = false;

	private get reportListFilter(): ReportListFilter {
		return new ReportListFilter([]);
	}

	private get isStateLocked(): boolean {
		if (this.bill === null) true;
		return this.bill.state === BillState.locked;
	}

	@Emit('billChanged')
	public billChanged(): void {
		return;
	}

	private edit(): void {
		this.editMode = true;
		this.loadSelection();
	}

	private save(): void {
		this.$emit('update:loading', true);
		this.$billService.assignReports(this.bill.id, this.selectedReports.map(r => r.id))
			.then(() => {
				this.editMode = false;
				this.selectedReports = [];
				this.billChanged();
			})
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.updateError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => this.$emit('update:loading', false));
	}

	private cancel(): void {
		this.editMode = false;
		this.selectedReports = [];
	}

	private loadSelection(): void {
		this.$emit('update:loading', true);
		this.$billService.reports(this.bill.id, null, null)
			.then(res => {
				this.selectedReports = res.data;
			})
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.loadingError'),
					color: 'error',
				} as SnackbarMessage);
			}).finally(() => this.$emit('update:loading', false));
	}

}
